import React from 'react';
import Cookies from 'universal-cookie'
import { API_USER_LOGIN } from './api'
import PayfazzLogin from './module/PayfazzLogin'

const cookies = new Cookies()

class Login extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      username: '',
      password: '',
      errorMsg: '',
      loading: false
    }
  }

  handelChangeUsername = (e) => this.setState({username: e.target.value})

  handleChangePassword = (e) => this.setState({password: e.target.value})

  handleSubmit = (e) => {
    e.preventDefault()
    let setParams = {
      username: this.state.username,
      password: this.state.password
    }
    this.setState({loading: true})
    API_USER_LOGIN(setParams)
      .then((response) => {
        cookies.set('tokenKYCSafecash', response.data.accessToken)
        cookies.set('usernameKYCSafecash', response.data.fullname)
        window.location.href = '/'
      })
      .catch((err)=>{
        if(err.response){
          this.setState({
            loading: false,
            errorMsg: err.response.data.message
          })
        }else{
          this.setState({
            loading: false,
            errorMsg: 'Network Error'
          })
        }
      })
  }

  render() {
    return (
      <PayfazzLogin
        onSubmit={this.handleSubmit}
        loading={this.state.loading}
        valueInput={this.state.username}
        valuePassword={this.state.password}
        onChangeInput={this.handelChangeUsername}
        onChangePassword={this.handleChangePassword}
        errorMsg={this.state.errorMsg}
      />
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/app/Login.js